import "./style.scss";

import { useBreakpoints } from "@amzn/stencil-react-components/dist/submodules/responsive";
import { Container, ContainerProps } from "@amzn/stencil-react-components/layout";
import React, { FC, ReactNode } from "react";

export interface PageMainContainerProps extends ContainerProps {
  children: ReactNode;
}

// Default root element font size: 16px
const CONTAINER_PROPS_MAP = {
  s: { paddingHorizontal: "1.5rem" }, // 16px * 1.5 = 24px
  default: { paddingHorizontal: "2rem" }, // 16px * 5 = 80px
};

/**
 * Container to handle the padding of new pages of the application
 */
export const PageMainContainer: FC<PageMainContainerProps> = (props: PageMainContainerProps) => {
  const { props: containerProps } = useBreakpoints<ContainerProps>({
    propsMap: CONTAINER_PROPS_MAP,
  });

  return (
    <Container {...props} {...containerProps}>
      {props.children}
    </Container>
  );
};
